import React, { useState } from 'react';
import { Container, Row, Col } from "reactstrap";
import { ChevronLeft, ChevronRight } from 'lucide-react';
import { faqSections } from './faqData';
import './faqs.css';

const MediaContent = ({ media }) => {
    if (!media) return null;

    switch (media.type) {
        case 'image':
            return (
                <div className="faq-media">
                    <img
                        src={media.url}
                        alt={media.alt}
                        className={media.className}
                        style={{
                            width: media.width ? `${media.width}px` : 'auto',
                            height: media.height ? `${media.height}px` : 'auto'
                        }}
                    />
                </div>
            );
        case 'video':
            return (
                <div className="faq-media">
                    <div className="faq-media-container">
                        <iframe
                            src={media.url}
                            title={media.alt}
                            frameBorder="0"
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                            allowFullScreen
                        />
                    </div>
                </div>
            );
        case 'gif':
            return (
                <div className="faq-media">
                    <img
                        src={media.url}
                        alt={media.alt}
                        className="faq-gif"
                    />
                </div>
            );
        default:
            return null;
    }
};

const Faqs = () => {
    document.title = "Usage Guideline - Data Collector"
    const [activeSection, setActiveSection] = useState('general');
    const [currentSlide, setCurrentSlide] = useState(0);

    const handleNext = () => {
        if (currentSlide < faqSections[activeSection].slides.length - 1) {
            setCurrentSlide(currentSlide + 1);
        }
    };

    const handlePrev = () => {
        if (currentSlide > 0) {
            setCurrentSlide(currentSlide - 1);
        }
    };

    const handleSectionChange = (section) => {
        setActiveSection(section);
        setCurrentSlide(0);
    };

    const currentSlideData = faqSections[activeSection].slides[currentSlide];
    const totalSlides = faqSections[activeSection].slides.length;

    return (
        <Container className='faq-container'>
            <Row>
                <Col md={3}>
                    <div className="faq-sidebar">
                        {Object.entries(faqSections).map(([key, section]) => (
                            <button
                                key={key}
                                onClick={() => handleSectionChange(key)}
                                className={`faq-menu-item ${activeSection === key ? 'active' : ''}`}
                            >
                                {section.title}
                            </button>
                        ))}
                    </div>
                </Col>

                <Col md={9}>
                    <div className="position-relative">
                        <div className={`faq-slide-card ${currentSlideData.bgColor}`}>
                            <div className="faq-progress">
                                {currentSlide + 1}/{totalSlides}
                            </div>

                            <div className="faq-content">
                                <h2 className="faq-subtitle">
                                    {currentSlideData.subtitle}
                                </h2>


                                {currentSlideData.media && (
                                    <MediaContent media={currentSlideData.media} />
                                )}
                                <p className="faq-description">
                                    {currentSlideData.description}
                                </p>

                                {currentSlideData.paragraphs && (
                                    <div className="faq-paragraphs">
                                        {currentSlideData.paragraphs.map((paragraph, index) => (
                                            <p key={index} className="faq-paragraph">
                                                {paragraph}
                                            </p>
                                        ))}
                                    </div>
                                )}

                                {currentSlideData.watchTutorial && (
                                    <button className="watch-tutorial-button">
                                        Watch Tutorial
                                    </button>
                                )}

                                {currentSlideData.bullets && (
                                    <ul className="bullet-list">
                                        {currentSlideData.bullets.map((bullet, index) => (
                                            <li key={index}>{bullet}</li>
                                        ))}
                                    </ul>
                                )}
                            </div>

                            {currentSlide > 0 && (
                                <div className="faq-navigation-arrow left" onClick={handlePrev}>
                                    <ChevronLeft size={24} />
                                </div>
                            )}
                            {currentSlide < totalSlides - 1 && (
                                <div className="faq-navigation-arrow right" onClick={handleNext}>
                                    <ChevronRight size={24} />
                                </div>
                            )}
                        </div>

                        <div className="faq-navigation-buttons">
                            {currentSlide > 0 && (
                                <button onClick={handlePrev} className="faq-navigation-button">
                                    Back
                                </button>
                            )}
                            {currentSlide < totalSlides - 1 && (
                                <button onClick={handleNext} className="faq-navigation-button">
                                    Next
                                </button>
                            )}
                        </div>
                    </div>
                </Col>
            </Row>
        </Container>
    );
};

export default Faqs;